import { JSX } from 'react';
import WindowBar from '../../../common/windowBar/windowBar';
import './timeOptions.css';

export type timeOption = 'Yearly' | 'Monthly' | 'Weekly' | 'Daily';
const timeOptions: timeOption[] = ['Yearly', 'Monthly', 'Weekly', 'Daily'];

interface TimeOptionProps {
    selectedTimeOption?: timeOption,
    setSelectedTimeOption: (option: timeOption) => void;
    closeWindow: () => void;
};

const TimeOptions = ({ setSelectedTimeOption, closeWindow }: TimeOptionProps): JSX.Element => {
    
    const handleOptionClick = (option: timeOption) => {
        setSelectedTimeOption(option);
        closeWindow();
    };

    return (
        <div className='time-option-position'>
            <div className='time-option-container main-pixel-container'>
                <WindowBar title='Time' IconSrc={null} onClick={closeWindow}/>
                <div className="divider-horizontal"/>
                <div className='time-options'>
                    {timeOptions.map((option) => (
                        <p key={option} onClick={()=>handleOptionClick(option)}>{option}</p>
                    ))}
                </div>
            </div>
        </div>
    ); 
};

export default TimeOptions;